import axios from "axios";
import { loginreq, req,reqGet} from "../axiosFun";

// 查询常见问题列表
export const getFagList = params => {
    return reqGet("get", "/app-yijiu-backstage/getFagList", params);
};

// 删除常见问题
export const deleteFag = params => {
    return reqGet("get", "/app-yijiu-backstage/deleteFag", params);
  };

// 添加常见问题  
export const addFag = params => {
    return req("post", "/app-yijiu-backstage/addFag", params);
};

// 修改常见问题  
export const updateFag = params => {
    return req("post", "/app-yijiu-backstage/updateFag", params);
};
  


// WEBPACK FOOTER //
// ./src/api/manage/fag.js